<template>
  <div style="margin: 20px; margin-left: 0px;">
    <el-form ref="xForm" :model="form">
      <el-form-item prop="name">
        <el-card class="box-card">
          <div slot="header">
            <h3 style="margin: 0">
              编辑分组名称
            </h3>
          </div>
          <div>
            <el-input v-model="form.name" placeholder="编辑分组组名" />
          </div>
        </el-card>
        <el-card class="box-card">
          <div slot="header">
            <el-row>
              <el-col :span="6">
                <el-autocomplete
                  v-model="autoData.vehicleLicenseNumber"
                  :fetch-suggestions="
                    (queryString, cb) =>
                      querySearchAsync('vehicle', queryString, cb)
                  "
                  placeholder="请输入车牌号"
                  clearable
                  @select="handleSelect"
                />
              </el-col>
              <el-col :span="6">
                <el-autocomplete
                  v-model="autoData.name"
                  :fetch-suggestions="
                    (queryString, cb) =>
                      querySearchAsync('name', queryString, cb)
                  "
                  placeholder="请输入实际承运人或车队名"
                  clearable
                  @select="handleSelect"
                />
              </el-col>
              <el-col :span="6">
                <el-autocomplete
                  v-model="autoData.phone"
                  :fetch-suggestions="
                    (queryString, cb) =>
                      querySearchAsync('phone', queryString, cb)
                  "
                  placeholder="请输入联系电话"
                  clearable
                  @select="handleSelect"
                />
              </el-col>
              <el-col :span="6">
                <el-button type="primary" @click="insertNewData">
                  增加
                </el-button>
                <el-button @click="clearNewData">
                  清空
                </el-button>
              </el-col>
            </el-row>
          </div>
          <vxe-table
            ref="xTable"
            resizable
            border
            highlight-hover-row
            :data="tableData"
          >
            <vxe-table-column field="vehicleLicenseNumber" title="车牌号" />>
            <vxe-table-column field="name" title="实际承运人或车队名" />>
            <vxe-table-column field="phone" title="联系电话" />>
            <vxe-table-column
              field="vehicleClassificationName"
              title="车辆类型"
            />
            <vxe-table-column title="操作" width="100px" fixed="right">
              <template slot-scope="scope">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="删除"
                  placement="top"
                >
                  <el-button
                    type="text"
                    @click="funcDelete(scope.row.driverCode)"
                  >
                    <i class="el-icon-delete" />
                  </el-button>
                </el-tooltip>
              </template>
            </vxe-table-column>
          </vxe-table>
        </el-card>
      </el-form-item>
      <el-form-item>
        <div style="text-align: right;">
          <el-button @click="funcCancel">
            取 消
          </el-button>
          <el-button type="primary" @click="funcSubmit">
            确 定
          </el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { getVehicleTeamDetail, addOrUpdateVehicleTeam } from "@/api/shipment";
export default {
  name: "VehicleTeamEdit",
  props: {
    restaurants: {
      type: Array,
      default() {
        return [];
      }
    },
    shipmentPartyCode: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      tableData: [],
      form: {
        name: "",
        partyCode: "",
        teamCode: "",
        driverCodes: []
      },
      tempData: null,
      autoData: {
        vehicleLicenseNumber: "",
        name: "",
        phone: ""
      }
    };
  },
  created() {
    this.form.partyCode = this.$route.query.code
      ? this.$route.query.code
      : this.shipmentPartyCode;
  },
  methods: {
    getInfo(name, code) {
      this.initData();
      this.form.name = name;
      this.form.teamCode = code;
      getVehicleTeamDetail({ teamCode: code, pageSize: 100 }).then(response => {
        this.tableData = response.data.page.records;
        this.tableData.forEach(item => {
          this.form.driverCodes.push(item.driverCode);
        });
      });
    },
    // 清空
    clearNewData() {
      this.autoData.vehicleLicenseNumber = "";
      this.autoData.name = "";
      this.autoData.phone = "";
    },
    // 新增
    insertNewData() {
      if (this.tempData) {
        var data = JSON.parse(JSON.stringify(this.tempData));
        // 新增数据与原数据结构不同
        data.driverCode = data.partyCode;
        this.tempData = null;
        // 检测是否有重复项
        if (this.form.driverCodes.indexOf(data.partyCode) > -1) {
          this.$message({
            message: "该实际承运人已存在，不能重复添加！",
            type: "warning"
          });
        } else {
          this.form.driverCodes.unshift(data.partyCode);
          this.tableData.unshift(data);
        }
        this.autoData.vehicleLicenseNumber = "";
        this.autoData.name = "";
        this.autoData.phone = "";
      } else {
        this.$message({ message: "请选择实际承运人！", type: "error" });
      }
    },
    // 删除
    funcDelete(driverCode) {
      var index = this.form.driverCodes.indexOf(driverCode);
      if (index > -1) {
        this.form.driverCodes.splice(index, 1);
      }
      this.tableData = this.tableData.filter(item => {
        return item.driverCode !== driverCode;
      });
    },
    // 模糊查询 车牌号/实际承运人姓名/联系电话
    querySearchAsync(type, queryString, cb) {
      switch (type) {
        case "vehicle":
          this.autoData.vehicleLicenseNumber = queryString;
          var temArr1 = this.filterList();
          temArr1.forEach(item => {
            item.value = item.vehicleLicenseNumber;
          });
          cb(temArr1);
          break;
        case "name":
          this.autoData.name = queryString;
          var temArr2 = this.filterList();
          temArr2.forEach(item => {
            item.value = item.name;
          });
          cb(temArr2);
          break;
        case "phone":
          this.autoData.phone = queryString;
          var temArr3 = this.filterList();
          temArr3.forEach(item => {
            item.value = item.phone;
          });
          cb(temArr3);
          break;
      }
    },
    // 筛选
    filterList() {
      var list = this.restaurants
        .filter(item => {
          if (item.vehicleLicenseNumber) {
            return (
              item.vehicleLicenseNumber.indexOf(
                this.autoData.vehicleLicenseNumber
              ) !== -1
            );
          } else {
            return true;
          }
        })
        .filter(item => {
          if (item.name) {
            return item.name.indexOf(this.autoData.name) !== -1;
          }
        })
        .filter(item => {
          if (item.phone) {
            return item.phone.indexOf(this.autoData.phone) !== -1;
          }
        });
      return list;
    },
    // 选中
    handleSelect(item) {
      this.tempData = item;
      this.autoData.vehicleLicenseNumber = this.tempData.vehicleLicenseNumber
        ? this.tempData.vehicleLicenseNumber
        : "";
      this.autoData.name = this.tempData.name ? this.tempData.name : "";
      this.autoData.phone = this.tempData.phone ? this.tempData.phone : "";
    },
    // 数据重置
    initData() {
      this.tempData = null;
      this.tableData = [];
      this.form.name = "";
      this.form.driverCodes = [];
      this.autoData = { vehicleLicenseNumber: "", name: "", phone: "" };
    },
    // 提交
    funcSubmit() {
      if (this.form.name) {
        if (this.form.driverCodes.length > 0) {
          var data = {
            name: this.form.name,
            teamCode: this.form.teamCode,
            partyCode: this.form.partyCode,
            driverCodes: this.form.driverCodes.join(",")
          };
          const rLoading = this.openLoading();
          addOrUpdateVehicleTeam(data).then(response => {
            rLoading.close();
            this.$message({ message: response.msg, type: "success" });
            this.$emit("fatherEditMethod");
          });
        } else {
          this.$message({ message: "请增加组员！", type: "error" });
        }
      } else {
        this.$message({ message: "请输入分组名称！", type: "error" });
      }
    },
    // 取消
    funcCancel() {
      this.$emit("fatherCancelMethod", "edit");
    }
  }
};
</script>
<style lang="scss" scoped>
.el-card {
  margin-bottom: 30px;
  &:last-child {
    margin-bottom: 0;
  }
  ::v-deep.el-card__header {
    padding-top: 10px;
    padding-bottom: 10px;
  }
}
</style>
